import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoFileReportsGetRes } from "./abst/DtoFileReportsGetRes";

export class DtoFileMastersGetResImple extends DtoFileReportsGetRes {}
